import React from "react";
import { useParams } from "react-router-dom";
import PageContent from "2g-page-content";

import ZdrojDetailComponent from "b2b/components/zdroj-detail/ZdrojDetail";

export function ZdrojDetail() {
  const { id } = useParams();

  return (
    <PageContent>
      <ZdrojDetailComponent id={id} />
    </PageContent>
  );
}

ZdrojDetail.propTypes = {};

export default React.memo(ZdrojDetail);
